import React from 'react';

interface Props {
    forwardedRef: any;
}

interface Options {
    direction: 'ltr' | 'rtl';
}

const withPageDirection = (WrappedComponent, options?: Options) => {
    const {direction} = options || {};

    function WithPageLTR(props: Props) {
        const {forwardedRef, ...rest} = props;
        return (
            <bdo dir={direction || 'ltr'}>
                <WrappedComponent ref={forwardedRef} {...rest} />
            </bdo>
        );
    }

    const forwardedComponent = React.forwardRef<any, any>((props: Props, ref) => {
        return <WithPageLTR {...props} forwardedRef={ref} />;
    });

    forwardedComponent.displayName = `withPageLTR(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;

    return forwardedComponent;
};

export default withPageDirection;
